import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import Rating from '@mui/material/Rating'
import htmlcss from '../Image/htmlcss.jpg'
import Php from '../Image/Php.jpg'
import Java from '../Image/Java.jpg'
import Python from '../Image/Python.jpg'
import Net from '../Image/Net.jpg'
import { BsArrowUpRight } from 'react-icons/bs'
import { FiArrowRightCircle } from 'react-icons/fi'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const courses = [
  {
    title: 'HTML/CSS',
    description:
      'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
    imageUrl: htmlcss,
    rating: 4,
    link: '/Artificial-Intelligence',
    alt: 'Artificial-Intelligence',
  },
  {
    title: 'PHP Course',
    description:
      'With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical...',
    imageUrl:Php,
    rating: 4,
    link: '/Cyber-Security',
    alt: 'Cyber-Security',
  },
  {
    title: 'Java Course',
    description:
      'In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects of HR, including performance...',
    imageUrl:Java,
    rating: 4,
    link: '/Human-Resources',
    alt: 'Human-Resources',
  },
  {
    title: 'Python Course',
    description:
      'Take a deep dive into the exciting world of marketing management and digital marketing. This course covers everything from comprehending...',
    imageUrl: Python,
    rating: 4,
    link: '/Digital-Marketing',
    alt: 'Digital-Marketing',
  },
  {
    title: '.Net Course',
    description:
      'VLSI technology has revolutionized the electronics industry by enabling the development of increasingly complex and powerful integrated...',
    imageUrl:Net,
    rating: 4,
    link: '/Vlsi-Design',
    alt: 'VLSI',
  },
]
const CourseWindow = ({ course }) => (
  <div className="container">
    <div className="" key={course.alt}>
      <Link className="Program_card_link" to={course.link}>
        <div className="border shadow-sm Program_card pb-1">
          <div className="p-3">
            <img className="border rounded" src={course.imageUrl} alt={course.title} />
          </div>
          <div className="px-3">
            <div className="row">
              <div className="col-md-10">
                <h1 className="pt-2">{course.title}</h1>
              </div>
              <div className="col-md-2">
                <BsArrowUpRight className="text-end" />
              </div>
              <p className="pt-1">{course.description}</p>
            </div>
            <h6>
              <b>Duration:</b>{' '}6 Week
            </h6>
            <h5 className="fw-normal pt-1">
              4.5{' '}
              <Rating
                name="half-rating-read"
                size="small"
                defaultValue={5}
                precision={4}
                readOnly
              />
            </h5>
          </div>
        </div>
      </Link>
    </div>
  </div>
);

export default function Coding_course_mobile() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      {courses.map((course, index) => (
        <Accordion
          key={index}
          className="py-2"
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index + 1}bh-content`}
            id={`panel${index + 1}bh-header`}
          >
            <Typography className="fs-5">{course.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <CourseWindow course={course} />
                  </div>
                </div>
                
      <div className="border rounded w-100 py-3 mt-4 px-2">
        <div className="combo_card_price">
        <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Assessment
          </h5>
          <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
            Sessions
          </h5>
          <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> One Certificate
          </h5>
          <h2>
            Program Price: ₹ 3,000
          </h2>
          <button className="px-4 py-2 bg-dark border rounded text-white">
            Enroll Now
          </button>
        </div>
      </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
